export function img(p) {
  return require("../../images/2023redesign/"+p);
}

export function imageReducer(desktopName, mobileName) {
  return window.screen.width > 767 ? img(desktopName) : img('mobileScreen/' + mobileName);
}